"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _reactMarkdown = _interopRequireDefault(require("react-markdown"));

var _remarkShortcode = _interopRequireDefault(require("@uplight/remark-shortcode"));

var _remarkSubSup = _interopRequireDefault(require("@uplight/remark-sub-sup"));

var _MarkdownLinkRenderer = _interopRequireDefault(require("./MarkdownLinkRenderer"));

var _MarketplaceShortcodes = _interopRequireDefault(require("./MarketplaceShortcodes"));

var _fragmentWrapperRenderer = _interopRequireDefault(require("./fragmentWrapperRenderer"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var CustomReactMarkdown = function CustomReactMarkdownComponent(_ref) {
  var className = _ref.className,
      source = _ref.source,
      renderers = _ref.renderers,
      tooltip = _ref.tooltip,
      noWrapper = _ref.noWrapper;
  var renderersCopy = renderers;

  if (noWrapper) {
    renderersCopy = _objectSpread(_objectSpread({}, _fragmentWrapperRenderer["default"]), renderers);
  }

  return /*#__PURE__*/_react["default"].createElement(_reactMarkdown["default"], {
    className: "custom-react-markdown".concat(className ? " ".concat(className) : ''),
    source: source,
    plugins: [_remarkShortcode["default"], _remarkSubSup["default"]],
    renderers: _objectSpread({
      link: _MarkdownLinkRenderer["default"],
      shortcode: function shortcode(props) {
        return /*#__PURE__*/_react["default"].createElement(_MarketplaceShortcodes["default"], _extends({}, props, {
          tooltip: tooltip
        }));
      },
      sub: 'sub',
      sup: 'sup'
    }, renderersCopy)
  });
};

CustomReactMarkdown.propTypes = {
  className: _propTypes["default"].string,
  source: _propTypes["default"].string.isRequired,
  renderers: _propTypes["default"].shape({}),
  tooltip: _propTypes["default"].shape({}),
  noWrapper: _propTypes["default"].bool
};
CustomReactMarkdown.defaultProps = {
  className: null,
  renderers: {},
  tooltip: null,
  noWrapper: false
};
var _default = CustomReactMarkdown;
exports["default"] = _default;